import { createBidirectionalMap } from './bidirectionalMap';
import type { SolarRowSpacingMode } from './types.generated';

export const solarRowSpacingModeMap =
  createBidirectionalMap<SolarRowSpacingMode>()({
    CALCULATED: 'calculated',
    FIXED: 'fixed',
  });
